import { render } from "./InformationBanner.vue?vue&type=template&id=28dc0184&scoped=true&ts=true"
import script from "./InformationBanner.vue?vue&type=script&lang=ts"
export * from "./InformationBanner.vue?vue&type=script&lang=ts"

import "./InformationBanner.vue?vue&type=style&index=0&id=28dc0184&scoped=true&lang=css"

import exportComponent from "/home/runner/work/qti-player/qti-player/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-28dc0184"]])

export default __exports__